"use strict";
exports.__esModule = true;
//# sourceMappingURL=bank-account.type.js.map